import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { RestrictionReason } from '../../Models/Models/Account/Restrictions/RestrictionReason';

declare var IS_RUNNING_IN_APP_POOL;

export class RestrictionReasonClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(customerId: number): Promise<Array<RestrictionReason>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Account/RestrictionReason/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { customerId: customerId }

    return AjaxWrapper.get<Array<RestrictionReason>, any>(url, data);
  }
}

